import { Typography } from "@mui/material";
import React, { useState, useEffect } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";

//bootstrap import
import { Container, Row, Col } from "react-bootstrap";
import ResponsiveDrawer from "../../components/responsiveDrawer/responsiveDrawer";

//component import
import Smallbox from "../../components/smallbox/smallbox";
import RecentJobs from "../../components/recentjobs/recentJobs";
import Cbtn from "../../components/commonbutton/cbtn";

//svg import
import { ReactComponent as Jobs } from "../../resources/svg/40-bag.svg";
//img
import graph from "../../resources/images/graph.png";

//scss import
import DashboardStyle from "./dashboard.module.scss";

//table import
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import { useSelector, useDispatch } from "react-redux";
import {
  checkLoginStatus,
  getSession,
  resetAuction,
  selectSession,
  selectStatus,
  selectAdmin,
  startAuction,
  stopAuction,
} from "../../store/features/adminSlice";
import LoadingScreen from "../../components/loadingSpinner/loadingScreen";
import AuctionMode from "../../components/auctionMode/auctionMode";
import ShareLinks from "../../components/shareLinks/shareLinks";
import {
  getBidder,
  selectbidderData,
} from "../../store/features/teamOwnerSlice";
import {
  getFranchise,
  selectfranchiseData,
} from "../../store/features/franchiseSlice";
import {
  getBiddingPlayers,
  selectbiddingPlayersData,
} from "../../store/features/biddingPlayerSlice";
import {
  getCurator,
  selectcuratorData,
} from "../../store/features/curatorSlice";

//use Selector
function createData(
  _id,
  bundleCode,
  bundleNumber,
  primaryColorCode,
  shadeCode,
  Piece,
  faultyStep,
  size,
  button
) {
  return {
    _id,
    bundleCode,
    bundleNumber,
    primaryColorCode,
    shadeCode,
    Piece,
    faultyStep,
    size,
    button,
  };
}

export default function Dashboard() {
  let location = useLocation();
  let dispatch = useDispatch();
  let navigate = useNavigate();
  const [validate, setValidate] = useState(false);
  const [show, setshow] = useState(false);
  const [acRow, setAcRow] = useState([
    createData(
      1,
      "100/001/C-1/30/XL",
      "100",
      "001#FF0000",
      "C-1#464646",
      "30",
      "180",
      "XL",
      "Re-Enable"
    ),
  ]);

  let loadingStatus = useSelector(selectStatus);
  let bidder = useSelector(selectbidderData);
  let franchise = useSelector(selectfranchiseData);
  let player = useSelector(selectbiddingPlayersData);
  let curator = useSelector(selectcuratorData);
  let session = useSelector(selectSession);

  useEffect(() => {
    if (
      bidder?.length > 0 &&
      franchise?.length > 0 &&
      curator?.length > 0 &&
      player?.length > 0
    ) {
      let worstBid = bidder?.filter((b) => b.owner === null);
      let worstTeam = franchise?.filter((b) => b.owner === null);
      if (!worstBid?.length && !worstTeam?.length) {
        setValidate(true);
      } else {
        setValidate(false);
      }
    } else {
      setValidate(false);
    }
  }, [bidder, franchise, player, curator]);

  useEffect(() => {
    if (location.hash) {
      let elem = document.getElementById(location.hash.slice(1));
      if (elem) {
        elem.scrollIntoView({ behavior: "smooth" });
      }
    } else {
      window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
    }
  }, [location]);

  useEffect(() => {
    if (loadingStatus === "error") {
      navigate("/login");
    }
  }, [loadingStatus]);

  useEffect(() => {
    dispatch(getBiddingPlayers());
    dispatch(getBidder());
    dispatch(getFranchise());
    dispatch(getCurator());
    dispatch(getSession());
  }, [loadingStatus]);

  const admin = useSelector(selectAdmin);

  const isLive = Boolean(session?._id && session?.active);
  const isPaused = Boolean(session?._id && !session?.active);

  const statIcon = (paths) => (
    <svg
      width="17"
      height="17"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      {paths}
    </svg>
  );

  const STATS = [
    {
      label: "Players",
      value: player?.length ?? 0,
      hint: `${player?.filter((p) => p.isSold)?.length ?? 0} sold so far`,
      link: "/biddingPlayers",
      icon: statIcon(
        <>
          <circle cx="9" cy="8" r="3.2" />
          <path d="M3.5 19c0-3 2.5-4.8 5.5-4.8s5.5 1.8 5.5 4.8" />
          <path d="M16 5.6a3.2 3.2 0 0 1 0 6.1" />
        </>
      ),
    },
    {
      label: "Teams",
      value: franchise?.length ?? 0,
      hint: `${
        franchise?.filter((f) => f.owner === null)?.length ?? 0
      } without an owner`,
      link: "/teams",
      icon: statIcon(
        <path d="M12 3 5 6v5.5c0 4 2.9 7.7 7 9.5 4.1-1.8 7-5.5 7-9.5V6z" />
      ),
    },
    {
      label: "Team Owners",
      value: bidder?.length ?? 0,
      hint: `${
        bidder?.filter((b) => b.owner === null)?.length ?? 0
      } without a team`,
      link: "/bidders",
      icon: statIcon(
        <>
          <rect x="3" y="5" width="18" height="14" rx="3" />
          <path d="m3.5 7.5 8.5 6 8.5-6" />
        </>
      ),
    },
    {
      label: "Curators",
      value: curator?.length ?? 0,
      hint: "Run the live auction",
      link: "/curators",
      icon: statIcon(
        <>
          <rect x="3" y="7" width="18" height="13" rx="3" />
          <path d="M9 7V5.5A1.5 1.5 0 0 1 10.5 4h3A1.5 1.5 0 0 1 15 5.5V7" />
        </>
      ),
    },
  ];

  // The same four conditions the validation effect above checks, surfaced one
  // by one so it is obvious which is blocking the start.
  const SETUP = [
    {
      text: "Add team owners",
      hint: bidder?.length ? `${bidder.length} added` : "None yet",
      done: bidder?.length > 0,
      link: "/bidders",
    },
    {
      text: "Add teams",
      hint: franchise?.length ? `${franchise.length} added` : "None yet",
      done: franchise?.length > 0,
      link: "/teams",
    },
    {
      text: "Assign every team an owner",
      hint:
        franchise?.filter((f) => f.owner === null)?.length ||
        bidder?.filter((b) => b.owner === null)?.length
          ? "Some are unassigned"
          : "All assigned",
      done:
        franchise?.length > 0 &&
        bidder?.length > 0 &&
        !franchise?.filter((f) => f.owner === null)?.length &&
        !bidder?.filter((b) => b.owner === null)?.length,
      link: "/teams",
    },
    {
      text: "Add players",
      hint: player?.length ? `${player.length} in the pool` : "None yet",
      done: player?.length > 0,
      link: "/biddingPlayers",
    },
  ];

  return (
    <>
      {loadingStatus === "Loading" && <LoadingScreen />}
      {loadingStatus === "fulfilled" && (
        <ResponsiveDrawer>
          <Container className={DashboardStyle.page}>
            <h1 className={DashboardStyle.hello}>
              Welcome back{admin?.name ? `, ${admin.name.split(" ")[0]}` : ""}
            </h1>
            <div className={DashboardStyle.helloSub}>
              {isLive
                ? "An auction is running right now."
                : validate
                ? "Everything is set up. You can start the auction whenever you are ready."
                : "Finish the steps below before the auction can start."}
            </div>

            {/* The counts were already being fetched for the validation check
                below; they were just never shown. */}
            <div className={DashboardStyle.statGrid}>
              {STATS.map((s) => (
                <Link
                  key={s.label}
                  to={s.link}
                  className={DashboardStyle.stat}
                >
                  <div className={DashboardStyle.statTop}>
                    <span className={DashboardStyle.statIcon}>{s.icon}</span>
                    <span className={DashboardStyle.statLabel}>{s.label}</span>
                  </div>
                  <div className={DashboardStyle.statValue}>{s.value}</div>
                  <div className={DashboardStyle.statHint}>{s.hint}</div>
                </Link>
              ))}
            </div>

            <AuctionMode />

            <div
              className={`${DashboardStyle.control} ${
                isLive
                  ? DashboardStyle.controlLive
                  : isPaused
                  ? DashboardStyle.controlPaused
                  : DashboardStyle.controlIdle
              }`}
            >
              <div>
                <div className={DashboardStyle.controlTitle}>
                  {isLive
                    ? "Auction is live"
                    : isPaused
                    ? "Auction is paused"
                    : "Auction not started"}
                </div>
                <div className={DashboardStyle.controlSub}>
                  {isLive
                    ? "Team owners can bid now. Stopping ends the session; resetting clears every sale and purse."
                    : isPaused
                    ? "The session still exists and keeps its results. Resume to carry on from where it stopped."
                    : validate
                    ? "Starting creates a session and opens bidding for every team owner."
                    : "Complete the setup steps below first."}
                </div>
              </div>

              <div className={DashboardStyle.controlActions}>
                {isLive && (
                  <>
                    <button
                      className={DashboardStyle.bigBtn}
                      onClick={async () => {
                        await dispatch(stopAuction(session?._id));
                        window.location.reload();
                      }}
                    >
                      <span className={DashboardStyle.liveDot} />
                      STOP AUCTION
                    </button>
                    <button
                      className={DashboardStyle.ghostBtn}
                      onClick={async () => {
                        if (
                          window.confirm(
                            "Are you sure? This will reset everything!"
                          )
                        ) {
                          await dispatch(resetAuction());
                          window.location.reload();
                        }
                      }}
                    >
                      Reset auction
                    </button>
                  </>
                )}

                {isPaused && (
                  <button
                    className={DashboardStyle.bigBtn}
                    onClick={async () => {
                      await dispatch(startAuction());
                      window.location.reload();
                    }}
                  >
                    RESUME AUCTION
                  </button>
                )}

                {!session?._id && !session?.active && (
                  <button
                    className={DashboardStyle.bigBtn}
                    disabled={!validate}
                    style={validate ? {} : { opacity: 0.45, cursor: "not-allowed" }}
                    onClick={async () => {
                      if (!validate) return;
                      await dispatch(startAuction());
                      window.location.reload();
                    }}
                  >
                    START AUCTION
                  </button>
                )}
              </div>
            </div>

            {/* The public links for this session. Renders itself away when
                there is no session to point at. */}
            <ShareLinks />

            {!validate && (
              <div className={DashboardStyle.setup}>
                <div className={DashboardStyle.setupTitle}>Before you start</div>
                <div className={DashboardStyle.setupSub}>
                  Each step turns green once it is done.
                </div>
                <div className={DashboardStyle.steps}>
                  {SETUP.map((step, i) => (
                    <Link
                      key={step.text}
                      to={step.link}
                      className={`${DashboardStyle.step} ${
                        step.done ? DashboardStyle.stepDone : ""
                      }`}
                    >
                      <span
                        className={`${DashboardStyle.stepMark} ${
                          step.done ? DashboardStyle.stepMarkDone : ""
                        }`}
                      >
                        {step.done ? "✓" : i + 1}
                      </span>
                      <div className={DashboardStyle.stepText}>{step.text}</div>
                      <div className={DashboardStyle.stepHint}>{step.hint}</div>
                    </Link>
                  ))}
                </div>
              </div>
            )}
          </Container>
        </ResponsiveDrawer>
      )}
    </>
  );
}
